import { render, staticRenderFns } from "./ezflycard.vue?vue&type=template&id=52d3c2ba"
import script from "./ezflycard.vue?vue&type=script&lang=js"
export * from "./ezflycard.vue?vue&type=script&lang=js"
import style0 from "./ezflycard.vue?vue&type=style&index=0&id=52d3c2ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports